<script setup lang="ts">
import { ref } from 'vue'
import { BarChart3, Boxes, Store } from 'lucide-vue-next'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
const phone = ref('13800000000')
const password = ref('')
const error = ref('')

async function submit() {
  error.value = ''
  if (!/^1\d{10}$/.test(phone.value) || password.value.length < 6) {
    error.value = '请输入正确手机号和至少 6 位密码'
    return
  }
  try {
    await auth.login(phone.value, password.value)
  } catch (reason) {
    error.value = reason instanceof Error ? reason.message : '登录失败'
  }
}
</script>

<template>
  <main class="login-shell">
    <section class="login-panel">
      <div class="login-brand">
        <div class="brand-mark">闫</div>
        <div class="brand-copy" style="display:grid"><strong style="color:var(--ink)">闫老大管理系统</strong><span>AI 熟食连锁智能管理平台</span></div>
      </div>
      <h1>欢迎回来</h1>
      <p class="intro">登录老板工作台，查看今日经营状态</p>
      <form class="login-form" novalidate @submit.prevent="submit">
        <div class="field"><label for="loginPhone">手机号</label><input id="loginPhone" v-model.trim="phone" inputmode="numeric" autocomplete="username" placeholder="请输入手机号"></div>
        <div class="field"><label for="loginPassword">密码</label><input id="loginPassword" v-model="password" type="password" autocomplete="current-password" placeholder="请输入密码"></div>
        <div class="error-text" aria-live="polite">{{ error }}</div>
        <button class="btn btn-primary" type="submit" :disabled="auth.busy">{{ auth.busy ? '登录中...' : '登录工作台' }}</button>
      </form>
    </section>
    <section class="login-visual" aria-hidden="true">
      <div class="login-overview">
        <h2>经营数据，集中掌握</h2>
        <p>从每日营业到库存流转，让门店经营信息保持清晰、及时和可追溯。</p>
        <div class="preview-grid">
          <div class="preview-item"><BarChart3 /><strong>营业分析</strong><span>门店收入与毛利趋势</span></div>
          <div class="preview-item"><Boxes /><strong>库存管理</strong><span>预警、调拨与报损记录</span></div>
          <div class="preview-item"><Store /><strong>连锁档案</strong><span>商品、门店与员工管理</span></div>
        </div>
      </div>
    </section>
  </main>
</template>
